import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import Registration from './Registration';

const RegisterMutation = gql`
  mutation register($user: IUserRegisterInput!) {
    register (
      user: $user 
    ) {
      token,
      user {
        id
      }
    }
  }
`;

const Countries = gql`
  query {
    countries {
      id
      parentCategoryId
      name
      code
      states {
        id
        name
        title
        vatRate
      }
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(RegisterMutation, {
    name: 'register'
  }),
  graphql<IInputProps, IResponse>(Countries, {
    name: 'countries'
  })
)(Registration);



// WEBPACK FOOTER //
// ./src/components/Query/User/Registration/index.tsx